// @mui
import { useSettingsContext } from 'src/components/settings';
import { useState, useCallback } from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';

// components
import Iconify from 'src/components/iconify';
import { hideScroll } from 'src/theme/css';
import ProductFeaturesSection from '../../product-pages/product-main-page/product-feature-section';
import ProjectManagementSection from './project-management-section';
import FinancialManagementSection from './financial-management-section';


// ----------------------------------------------------------------------

const TABS = [
  {
    value: 'Product Feature',
    label: 'Product Feature',
    icon: <Iconify icon="solar:home-bold" width={22} />,
    color: '#4CAF50',
  },
  {
    value: 'Project Management',
    label: 'Project Management',
    icon: <Iconify icon="ant-design:solution-outlined" width={22} />,
    color: '#2196F3',
  },
  {
    value: 'Financial Management',
    label: 'Financial Management',
    icon: <Iconify icon="ant-design:solution-outlined" width={22} />,
    color: '#2196F3',
  },


];

export default function ProductTabMenu({ avtiveMenu }) {
  const settings = useSettingsContext();
  const theme = useTheme();
  console.log('active menu', avtiveMenu);
  const [currentTab, setCurrentTab] = useState('Product Feature');

  const handleChangeTab = useCallback((event, newValue) => {
    setCurrentTab(newValue);
  }, []);

  return (
    <>
      {/* <Card> */}
      {/* <CardHeader
          title="Website Home Page Sections"
          subheader="Manage content for each section of your website's home page"
        />
        <Divider /> */}
      <Box
        sx={{
          position: 'relative',
          px: 3,
          pt: 2,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            borderRadius: 1,
            bgcolor: (theme) => alpha(theme.palette.primary.lighter, 0.8),
            mb: 2,
            py: 0,
            overflow: 'hidden',
          }}
        >
          <Stack
            direction="row"
            sx={{
              width: '100%',
              overflowX: 'auto',
              ...hideScroll.x,
              flexWrap: { xs: 'nowrap', md: 'wrap' },
              pb: { xs: 1, md: 0 },
            }}
          >
            <Tabs
              value={currentTab}
              onChange={handleChangeTab}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              TabIndicatorProps={{
                sx: {
                  display: 'none', // Remove indicator completely
                },
              }}
              sx={{
                px: 2,
                '& .MuiTabs-flexContainer': {
                  gap: 0,
                },
                '& .MuiTab-root': {
                  minWidth: 'auto',
                  minHeight: 40,
                  fontWeight: 600,
                  borderRadius: 1,
                  mt: 0.5,
                  textTransform: 'capitalize',
                  px: 1,
                  '&:hover': {
                    bgcolor: 'background.paper',
                    color: 'primary.main',
                  },
                  '&.Mui-selected': {
                    bgcolor: 'background.paper',
                    color: 'primary.main',
                    boxShadow: theme.customShadows.z8,
                  },
                },
              }}
            >
              {TABS.map((tab) => (
                <Tab
                  key={tab.value}
                  value={tab.value}
                  label={
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {tab.icon}
                      </Box>
                      <Box component="span">{tab.label}</Box>
                    </Stack>
                  }
                  sx={{
                    '&.Mui-selected': {
                      color: tab.color,
                      '& svg': { color: tab.color },
                    },
                  }}
                />
              ))}
            </Tabs>
          </Stack>
        </Paper>
      </Box>

      <Box sx={{ p: 3 }}>
        {currentTab === 'Product Feature' && (
          <Box sx={{ mt: 1 }}>
            <ProductFeaturesSection />
          </Box>
        )}

        {currentTab === 'Project Management' && (
          <Box sx={{ bgcolor: (theme) => alpha(theme.palette.primary.lighter, 0.08), borderRadius: 2 }}>
            <Stack spacing={2}>
              <ProjectManagementSection />
            </Stack>
          </Box>
        )}

        {currentTab === 'Financial Management' && (
          <Box sx={{ bgcolor: (theme) => alpha(theme.palette.primary.lighter, 0.08), borderRadius: 2 }}>
            <Stack spacing={2}>
              <FinancialManagementSection />
            </Stack>
          </Box>
        )}

      </Box>
      {/* </Card> */}
    </>
  );
}
